
// firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// IMPORTANT: fix storage bucket
const firebaseConfig = {
    apiKey: "AIzaSyAavmK-frl6kN23LCN-0rYtMS-EN62HtbY",
    authDomain: "learnapp-85813.firebaseapp.com",
    projectId: "learnapp-85813",
    storageBucket: "learnapp-85813.firebasestorage.app",   // FIXED
    messagingSenderId: "780490730452",
    appId: "1:780490730452:web:1f0227a57162674d3b0441",
};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1");
export const storage = getStorage(app); // <-- hier

